/**
***************************************************************************
* NAME 			: TeamMembers
* PROPS	 		: members (array) (required)
*				: (all members of the team excluding the requestor)
*				: - employeeID
*				: - firstName
*				: - lastName
*				: - name (full name)
*				: - teamId
*				: - team
*				: - supervisorEmployeeID
*				: - dailyStatusInd
*				: - dailyStatusCompletedInd
*				: - projectScheduleInd
* RETURNS 		: Listing of employees to access Workamajig reports
* LAST MODIFIED 	: October 28, 2025
***************************************************************************
*/

import EmployeeReportCard from '../../UI/EmployeeReportCard';

const TeamMembers = (props) => {
	return (
		<>
			<div className="outer-flexwrap">
				<div className="pageitem">
					<h3>My Team Members</h3>
					<div className="flexwrap_empcards">
						{
							props.members.map(employee => (
								<EmployeeReportCard
									key={employee.employeeId}
									id={employee.employeeId}
									firstName={employee.firstName}
									lastName={employee.lastName}
									dailyStatusInd={employee.dailyStatusInd}
									dailyStatusSubmittedInd={employee.dailyStatusSubmittedInd}
									projectScheduleInd={employee.projectScheduleInd}
								/>
							))
						}
					</div>
				</div>
			</div>
		</>
	)
}

export default TeamMembers;
